import React, { useState } from "react";

import img1 from '../../assets/images/png_pic/self-4.png';
import img2 from '../../assets/images/png_pic/self-6.png';
import img3 from '../../assets/images/png_pic/self-7.png';
import img4 from '../../assets/images/png_pic/wall-1.png';
import img5 from '../../assets/images/png_pic/wall-4.png';
import img6 from '../../assets/images/png_pic/wall-3.png';
import img7 from '../../assets/images/png_pic/errect-1.png';
import img8 from '../../assets/images/png_pic/errect-3.png';
import img9 from '../../assets/images/png_pic/titable-1.png';
import img10 from '../../assets/images/png_pic/tilable-3.png';
import img11 from '../../assets/images/png_pic/trolley-step-1.png';
import img12 from '../../assets/images/png_pic/trolley-step-2.png';




// Project data
const projects = [
  { id: 1, title: "Self supporting ladder", category: "Self & Wall Supporting", image: img1, description: "Specially made for Shops, Godpwns and Domestic Applications, Height available, size 3 feet to 15 feet" },
  { id: 2, title: "Wall Supporting Ladder", category: "Self & Wall Supporting", image: img4, description: "Height available, size 7 feet to 10 feet." },
  { id: 3, title: "Errect Tower Ladder", category: "Errect Tower Ladder", image: img7, description: "Specially made for highted working platforms." },
  { id: 4, title: "Trolly Step Ladder", category: "Trolly Step Ladder", image: img11, description: "Wide Steps & Side Raillings Locking Arrangement Available for Wheets 5 feets to 12 feet" },
  { id: 5, title: "Self supporting ladder", category: "Self & Wall Supporting", image: img2, description: "Specially made for Shops, Godpwns and Domestic Applications, Height available, size 3 feet to 15 feet" },
  { id: 6, title: "Tiltable Tower Ladder", category: "Tiltable Tower Ladder", image: img9, description: "Ideal for factroies with low opening, Street light maintenance, Ware house, Railway station, Auditorium, Hotels, Educational institutions and Electrical Departments." },
  { id: 7, title: "Wall Supporting Ladder", category: "Self & Wall Supporting", image: img5, description: "movable wheel & locking system" },
  { id: 8, title: "Errect Tower Ladder", category: "Errect Tower Ladder", image: img8, description: "movable wheel & locking system" },
  { id: 9, title: "Tiltable Tower Ladder", category: "Tiltable Tower Ladder", image: img10, description: "Ideal for factroies with low opening, Street light maintenance, Ware house, Railway station, Auditorium, Hotels, Educational institutions and Electrical Departments." },
  { id: 10, title: "Trolly Step Ladder", category: "Trolly Step Ladder", image: img12, description: "Light weighted and Extendable wall support ladder" },

  { id: 11, title: "Self supporting ladder", category: "Self & Wall Supporting", image: img3, description: "Specially made for Shops, Godpwns and Domestic Applications, Height available, size 1 feet to 2 feet" },
  { id: 12, title: "Wall Supporting Ladder", category: "Self & Wall Supporting", image: img6, description: "Wall supporting light weighted ladder. Height available, size 3 feet to 5 feet." },
];

// Category list
const categories = ["All Models", "Trolly Step Ladder", "Errect Tower Ladder", "Tiltable Tower Ladder", "Self & Wall Supporting",];

const Portfolio = () => {
  const [selectedCategory, setSelectedCategory] = useState("All Models");
  const [selectedProject, setSelectedProject] = useState(null); // State for the selected project

  // Filter projects based on selected category
  const filteredProjects =
    selectedCategory === "All Models"
      ? projects
      : projects.filter((project) => project.category === selectedCategory);

  // Function to open modal for a project
  const openModal = (project) => {
    setSelectedProject(project);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedProject(null);
  };

  return (
    <section className="container mx-auto py-8 px-4" data-aos="fade-up"
    data-aos-duration="2000">
      <h2 className="text-center text-2xl md:text-4xl font-semibold mb-4 text-[#182e55]">Our Recent Projects</h2>
      <p className="text-center text-gray-600 mb-8 max-w-2xl mx-auto ">
      We provide the ladders are crafted from the finest aluminum, ensuring long-lasting durability without the added weight.
      </p>
      
      {/* Category Buttons */}
      <div className="flex flex-wrap justify-center space-x-4 mb-8">
        {categories.map((category) => (
          <button
            key={category}
            className={`px-4 py-2 my-2 rounded-lg text-sm font-medium ${
              selectedCategory === category ? "bg-[#234279] text-white" : "bg-gray-200 text-gray-800"
            }`}
            onClick={() => setSelectedCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Projects Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredProjects.map((project) => (
          <div key={project.id} className="bg-white shadow-lg rounded-lg p-4">
            <img
              src={project.image}
              alt={project.title}
              className="w-full h-48  rounded-t-lg"
            />
            <div className="p-4">
              {/* <h3 className="text-blue-600 font-medium mb-2">{project.category}</h3> */}
              <h4 className="text-lg font-semibold mb-2">{project.category}</h4>
              <button
                className="mt-2 bg-[#182e55] py-2 px-4 rounded-lg text-white text-sm hover:bg-[#234279] font-medium"
                onClick={() => openModal(project)}
              >
                View Details
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {selectedProject && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md md:max-w-lg lg:max-w-xl">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-2xl font-bold">{selectedProject.title}</h3>
              <button className="text-gray-500 hover:text-gray-700 text-lg" onClick={closeModal}>
                &times;
              </button>
            </div>
            <img
              src={selectedProject.image}
              alt={selectedProject.title}
              className="w-full h-72 md:h-80 rounded-lg mb-4"
            />
            <p className="text-gray-700 mb-4">{selectedProject.description}</p>
            <button
              className="bg-blue-600 text-white py-2 px-4 rounded-lg"
              onClick={closeModal}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default Portfolio;
